import config from "@config"

const currentTemplate = config.template.name || "base"

export default import(`../${currentTemplate}/store/index.js`).then((registers) => registers.default)
